import * as moment from 'moment';
import { DateTimeConverter } from 'src/app/core/services/mapper/converters';

export class Prelevement {
    static jsonMap = {
        date: { key: 'datePrelevement', converter: new DateTimeConverter(), optional: true },
        observation: { key: 'observation', optional: true, default: '' },
        representant: { key: 'representant', optional: true, default: '' }
    };

    date: moment.Moment;
    observation: string;
    representant: string;
}
